export const MODAL_DEFAULT_SIZE = "small";
